import React, { Component } from 'react';
import BannerI from "../../components/banner/BannerI";
import Advantages from "../../components/home/Advantages";
import "./home.css";
import axios from "axios";
import qs from 'qs';
import { ALIBABA_PASS, ALIBABA_USER, ALIBABA_URL, API_URL } from "../../config/Config";
import { toast } from "react-toastify";
import { otherAirport } from '../../redux/actions/airport';
import { changeSetting } from '../../redux/actions/setting';
import { setPrice } from '../../redux/actions/price';
import axiosRetry from 'axios-retry';
import { ACCESS_TOKEN, REFRESH_TOKEN } from "../../redux/actions/setting";
import SectionLoader from "../../components/loader/SectionLoader";
import { connect } from 'react-redux';

axiosRetry(axios, { retries: 3 });

class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            hasAlert: false,
        };
    }

    async componentDidMount() {
        const options = {
            method: 'GET',
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
            url: `${API_URL}setting/1`,
        };

        let response = await axios(options);
        // console.log(response);
        response.data.data.currency = "EUR";
        this.props.dispatch(changeSetting(response.data.data))


        const optionsprice = {
            method: 'GET',
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
            url: `${API_URL}prices/1`,
        };
        let responseprice = await axios(optionsprice);

        // const persent = responseprice.data[0].increase_percent;
        // const amount = responseprice.data[0].increase_amount;
        this.props.dispatch(setPrice(responseprice.data[0]));
        // console.log('responseprice');
        // console.log(responseprice);

        await this.handleRequest();
    }


    render() {
        return (
            <div>
                {!this.state.loading ?
                    <SectionLoader type="spinningBubbles" color="#0ebcf2" /> :
                    <BannerI />
                }
                <div className="clearfix" />
                <section className="w-100 section-home home-icons"
                // style={{ background: "white", borderBottom: "3px solid #43b185" }}
                >
                    <Advantages />
                </section>

            </div>
        );
    }
    async handleRequest() {
        this.setState({ loading: true });
        try {
            let data = {
                'username': `${ALIBABA_USER}`,
                'password': `${ALIBABA_PASS}`,
                'client_Id': "00000",
                'grant_type': "password",
            };
            const options = {
                method: 'POST',
                headers: { 'content-type': 'application/x-www-form-urlencoded' },
                data: qs.stringify(data),
                url: `${ALIBABA_URL}token`,
            };

            // let response = await axios.post(`${ALIBABA_URL}token`,data,config);
            let response = await axios(options);

            if (response.status < 200 || response.status > 300) {
                const error = new Error(response.statusText);
                error.response = response;
                console.log(error);
                toast.error('An error occurred while receiving information from the server.', {
                    autoClose: 3000,
                    position: toast.POSITION.TOP_RIGHT,
                    rtl: false
                });
            } else {
                let data = response.data;
                localStorage.setItem(ACCESS_TOKEN, data.access_token);
                localStorage.setItem(REFRESH_TOKEN, data.refresh_token);
                this.props.dispatch(otherAirport())
            }
        } catch (e) {
            let apiError = await e.response;
            if (apiError === undefined) {
                console.log(e);
            } else {
                let statusText = await apiError.statusText;
                console.log(statusText);

            }
        }
        this.setState({ loading: true });
    };
}

export default connect()(Home)


// WEBPACK FOOTER //
// ./src/containers/home/Home.js